var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModulePayroll(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 33C26.2843 33 31.3929 22.8215 31.3929 22.8215C31.3929 22.8215 21.75 33 12.1071 22.8215C4.60714 12.6429 11.0357 4.60718 11.0357 4.60718C6.75 7.28575 3 9.71576 3 18C3 26.2843 9.71573 33 18 33Z",
    fill: "#D6D6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0078 21.4948C13.0078 23.4298 14.4928 24.9898 16.3378 24.9898H20.1028C21.7078 24.9898 23.0128 23.6248 23.0128 21.9448C23.0128 20.1148 22.2178 19.4698 21.0328 19.0498L14.9878 16.9498C13.8028 16.5298 13.0078 15.8848 13.0078 14.0548C13.0078 12.3748 14.3128 11.0098 15.9178 11.0098H19.6828C21.5278 11.0098 23.0128 12.5698 23.0128 14.5048",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9V27",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33Z",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModulePayroll);
export default __webpack_public_path__ + "static/media/module-payroll.1e39b7c8.svg";
export { ForwardRef as ReactComponent };